import Header from "components/Headers/Header";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Modal,
  ModalBody,
  Row,
  Spinner,
  Alert
} from "reactstrap";
import { getWalletLog, getWallet } from "store/actions/walletAction";
import moment from "moment";
import ReuseableTable from "components/Tables/ReuseableTable";
import WithdrawModal from "components/modals/WithdrawModal";

const Wallet = () => {
  const dispatch = useDispatch();
  const { uid } = useSelector((state) => state.auth);
  const { amount, wallet_log, lastDocument, hasMoreDocument } = useSelector(
    (state) => state.wallet
  );
  const [modal, setModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadMoreLoader, setLoadMoreLoader] = useState(false);
  const [noteModal, setNoteModal] = useState(false);

  const toggle = () => {
    setModal(!modal);
  };
  const toggleNoteModal = () => {
    setNoteModal(!noteModal);
  };

  const loadMore = () => {
    setLoadMoreLoader(true);
    dispatch(
      getWalletLog(uid, lastDocument, () => {
        setLoadMoreLoader(false);
      })
    );
  };

  const columns = [
    "Payment Type",
    "Amount",
    "Date",
    "Service Type",
    "Resource Id"
  ];

  const keyMap = {
    "Payment Type": "paymentType",
    Amount: "amount",
    Date: "date",
    "Service Type": "serviceType",
    "Resource Id": "resourceId"
  };

  useEffect(() => {
    setIsLoading(true);
    const unsubscribe = dispatch(getWallet(uid));
    dispatch(
      getWalletLog(uid, "", () => {
        setIsLoading(false);
      })
    );
    return () => {
      if (unsubscribe && typeof unsubscribe === "function") unsubscribe();
    };
  }, [dispatch, uid]);

  const isSmallScreen = window.innerWidth < 768;

  return (
    <>
      <Header />
      {isLoading ? (
        <div className="d-flex align-items-center justify-content-center vh-100">
          <Spinner color="primary" />
        </div>
      ) : (
        <Container className="mb-5 mt--4" fluid>
          {/* Main Balance Card */}
          <Card className="shadow border-0 rounded-4 overflow-hidden mb-4 bg-white p-4">
            <Row className="align-items-center">
              {/* Left Side: Balance info */}
              <Col md="7" className="mb-3 mb-md-0">
                <span className="text-uppercase tracking-wider text-muted font-weight-700" style={{ fontSize: "11px" }}>
                  Earning Overview
                </span>
                <h3 className="h1 text-dark font-weight-800 mb-1 mt-1">
                  My Wallet
                </h3>
                <div className="d-flex align-items-baseline mt-3">
                  <span className="h1 text-primary font-weight-900 mr-2" style={{ fontSize: "3.5rem" }}>
                    ${amount ? Number(amount)?.toFixed(2) : "0.00"}
                  </span>
                  <span className="text-muted font-weight-600">USD</span>
                </div>
                <div className="mt-4">
                  <Button
                    color="primary"
                    size="lg"
                    className="rounded-pill px-5 shadow font-weight-bold"
                    onClick={toggle}
                  >
                    <i className="fas fa-wallet mr-2"></i> Withdraw Funds
                  </Button>
                </div>
              </Col>

              {/* Right Side: PayPal Warning Note */}
              <Col md="5">
                <Alert color="warning" className="border-0 rounded-4 p-3 mb-0" style={{ backgroundColor: "#fffbeb", borderLeft: "4px solid #fb6340" }}>
                  <h5 className="alert-heading font-weight-700 text-warning-darker mb-2" style={{ color: "#b25e00" }}>
                    <i className="fas fa-exclamation-triangle mr-2"></i> Important Note
                  </h5>
                  <p className="mb-0 text-muted" style={{ fontSize: "0.85rem", lineHeight: "1.5" }}>
                    Amounts shown are approximate. PayPal may apply fees for withdrawals or account-to-account transfers.
                  </p>
                </Alert>
              </Col>
            </Row>
          </Card>

          {/* Transactions Table Card */}
          <Card className="shadow border-0 rounded-4 overflow-hidden mt-4">
            <CardHeader className="bg-white border-0 pb-0 pt-4">
              <h3 className="mb-0 text-dark font-weight-700 px-2">
                <i className="fas fa-exchange-alt text-primary mr-2"></i> Transaction Log
              </h3>
            </CardHeader>
            <CardBody className="pt-0">
              <ReuseableTable
                columns={columns}
                data={wallet_log?.map((items) => ({
                  ...items,
                  paymentType: items?.paymentType,
                  amount: items?.amount && Number(items?.amount)?.toFixed(2),
                  date: moment
                    .unix(items?.createdAt?.seconds)
                    .format("MMMM D, YYYY"),
                  serviceType: items?.serviceType,
                  resourceId: items?.resourceId
                }))}
                keyMap={keyMap}
              />

              {!isLoading && (
                <div className="w-100 p-3 d-flex justify-content-center">
                  {wallet_log.length > 4 && (
                    <div className="text-center">
                      <Button
                        color="primary"
                        onClick={loadMore}
                        disabled={!hasMoreDocument || loadMoreLoader}
                      >
                        {loadMoreLoader ? <Spinner size="sm" /> : " Load more"}
                      </Button>
                    </div>
                  )}
                </div>
              )}
            </CardBody>
          </Card>
        </Container>
      )}

      <WithdrawModal isOpen={modal} toggle={toggle} />

      <Modal isOpen={noteModal} toggle={toggleNoteModal} size="sm" centered>
        <ModalBody className="p-4">
          <h5 className="font-weight-700 text-dark mb-3">Approximate Amounts</h5>
          <p className="text-muted" style={{ fontSize: "0.9rem" }}>
            Note: Amount shown is only approximate. PayPal may apply fees for withdrawals or account-to-account transfers.
          </p>
          <div className="text-right mt-4">
            <Button color="primary" size="sm" className="rounded-pill px-4" onClick={toggleNoteModal}>
              Ok
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default Wallet;
